import { Column, Row, Skeleton } from 'components/Blocks';

function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function LoadingInvoice(): JSX.Element {
  return (
    <Column>
      <div />

      <Skeleton quantity={3} orientation="horizontal" gap="2" height={30} width={90} />

      <Column>
        {[...Array(6)].map((_, index) => (
          <Row key={`property-fake-${index}`}>
            <Skeleton height={32} width={32} circle />

            <Skeleton
              quantity={2}
              orientation="horizontal"
              height={22}
              widths={[`${getRandomInt(10, 15)}%`, `${getRandomInt(30, 60)}%`]}
              fullWidth
            />
          </Row>
        ))}
      </Column>

      <Row justifyContent="center">
        <Skeleton height={30} width={162} />
      </Row>

      <Column>
        {[...Array(2)].map((_, index) => (
          <Row key={`project-fake-${index}`}>
            <Skeleton height={32} width={32} circle />

            <Skeleton
              quantity={2}
              orientation="horizontal"
              height={22}
              widths={[getRandomInt(50, 140), getRandomInt(50, 180)]}
            />
          </Row>
        ))}
      </Column>
    </Column>
  );
}
